import React from 'react'

export default () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(1 1)" fill="none" fillRule="evenodd">
      <text
        fontFamily="SceneStd-Medium, Scene Std"
        fontSize="13"
        fontWeight="400"
        letterSpacing=".244"
        fill="#AD4360"
      >
        <tspan x="8" y="15">
          !
        </tspan>
      </text>
      <circle stroke="#AC4461" cx="10" cy="10" r="10" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/exclamationIcon.js